import { render, staticRenderFns } from "./nearActivity.vue?vue&type=template&id=23666a43&scoped=true&"
import script from "./nearActivity.vue?vue&type=script&lang=js&"
export * from "./nearActivity.vue?vue&type=script&lang=js&"
import style0 from "./nearActivity.vue?vue&type=style&index=0&id=23666a43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23666a43",
  null
  
)

export default component.exports